function Footer() {
  return (
    <div className="footer">
      <h3>&copy; 2025</h3>
    </div>
  );
}

export default Footer;
